import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { getMyOutlookEligibilityState } from '../selectors/getMyOutlookProductState';
import { isMyOutlookProductFlightEnabled } from './isMyOutlookProductFlightEnabled';
import { getPersonalOsHost } from 'owa-personal-os-host';
import { isPersonalOSCapabilityEnabled } from 'owa-copilot-settings-utils/lib/utils/isCopilotFeatureEnabled';

export { isMyOutlookProductFlightEnabled } from './isMyOutlookProductFlightEnabled';

export function isMyOutlookProductEnabled(mailboxInfo: MailboxInfo): boolean {
    if (!isMyOutlookProductFlightEnabled(mailboxInfo)) {
        return false;
    }
    if (getPersonalOsHost() === 'owa' && !isPersonalOSCapabilityEnabled(mailboxInfo)) {
        return false;
    }
    if (!isMyOutlookEligibilityGateEnabled(mailboxInfo)) {
        return true;
    }
    const eligibility = getMyOutlookEligibilityState(mailboxInfo);
    return eligibility.availability === 'ready' && eligibility.isFeatureVisible === true;
}

export function isMyOutlookEligibilityGateEnabled(mailboxInfo: MailboxInfo): boolean {
    return isAccountFeatureEnabled('acct-personalos-eligibility', mailboxInfo);
}

/** On by default; enable the killswitch flight to restore the legacy briefing settings. */
export function isBriefingUserDisableExperienceEnabled(mailboxInfo: MailboxInfo): boolean {
    return !isAccountFeatureEnabled(
        'acct-personalos-briefing-user-disable-killswitch',
        mailboxInfo
    );
}
